import { Flex, Typography } from 'antd';
import moment from 'moment';
import React from 'react';

import { PREFIX } from '@app/constants';
import type { NTasksList } from '@app/pages/TasksList/types/TasksList.types';

const { Text } = Typography;

export const Comment: React.FC<NTasksList.CommentProps> = ({ comment }) => {
  const { Text: CommentText, TimeCreated, UserCreator } = comment;
  const { NameFirst, NameLast } = UserCreator;

  return (
    <div className={`${PREFIX}task-comment-component`}>
      <Flex vertical={true}>
        <Text>{CommentText}</Text>
        <Text type="secondary">
          {`${moment(TimeCreated).format('HH:mm DD MMMM YYYY')} - ${
            NameLast || ''
          } ${NameFirst || ''}`}
        </Text>
      </Flex>
    </div>
  );
};
